import React from "react";
import { Link } from "react-router-dom";
import { logo } from "../constant";

const Header = () => {
  return (
    <>
      <header id="top">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="header-menu-list-wrapper">
                <ul>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Home
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Inventory
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Find you EV
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Sell Your Ev
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="logo-wrapper">
                <Link>
                  <img src={logo} className="img-fluid" alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="header-menu-list-wrapper">
                <ul>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Why Electric?
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      About Us
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Contact Us
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/" className="menu-link">
                      Get Approved
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
